import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { ManufacturerDto } from "./manufacturer.dto";
import { CreateManufacturerDto } from "./create-manufacturer.dto";
import { UpdateManufacturerDto } from "./update-manufacturer.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class ManufacturersResource extends ResourceBaseService<
  ManufacturerDto,
  CreateManufacturerDto,
  UpdateManufacturerDto
> {
  protected EntityDto = ManufacturerDto;
  protected CreateEntityDto = CreateManufacturerDto;
  protected UpdateEntityDto = UpdateManufacturerDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/manufacturers");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
